import { render, staticRenderFns } from "./CreateOrderMovementInternal.vue?vue&type=template&id=6a2ff9bc&scoped=true"
import script from "./CreateOrderMovementInternal.vue?vue&type=script&lang=js"
export * from "./CreateOrderMovementInternal.vue?vue&type=script&lang=js"
import style0 from "./CreateOrderMovementInternal.vue?vue&type=style&index=0&id=6a2ff9bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2ff9bc",
  null
  
)

export default component.exports